import React from 'react';
import { style } from 'typestyle';
import { useOfficeManagersForUser } from '../hooks/users.hook';
import * as styles from './registration.styles';
import RegisterOfficeManagersGroup from '../groups/register-office-manager-group.component';
import { useAdminOrAuthorOffices } from '../../offices/hooks/offices.hook';
import { Center } from '../../../core/components/center/center.component';
import ActivityIndicator from '../../../core/components/activity-indicator/activity-indicator.component';
import StyleConstants from '../../../core/styles.constants';

const RegisterOfficeManagers = (): React.JSX.Element => {
  const officeManagers = useOfficeManagersForUser();
  const { offices } = useAdminOrAuthorOffices();

  return (
    <div className={style(styles.pageMargin)}>
      {!officeManagers.initialized ? (
        <Center>
          <ActivityIndicator size={20} color={StyleConstants.GREY_COLOR} />
        </Center>
      ) : (
        <RegisterOfficeManagersGroup allOfficeManagers={officeManagers.users} offices={offices} />
      )}
    </div>
  );
};

export default RegisterOfficeManagers;
